import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';

export enum EmailVerificationError {
  InvalidToken = 'InvalidToken',
  ExpiredToken = 'ExpiredToken',
  AlreadyVerified = 'AlreadyVerified',
  NotFound = 'NotFound',
  InvalidEmail = 'InvalidEmail',
}

@Component({
  selector: 'app-error',
  imports: [CommonModule, RouterLink, TranslocoModule],
  templateUrl: './error.component.html',
})
export class ErrorComponent {
  @Input() error: EmailVerificationError | null = null;
  @Input() email: string = '';
  @Input() scope = 'emailVerification';

  EmailVerificationError = EmailVerificationError;

  getErrorKey(): string {
    switch (this.error) {
      case EmailVerificationError.InvalidToken:
        return 'invalidToken';
      case EmailVerificationError.ExpiredToken:
        return 'expiredToken';
      case EmailVerificationError.AlreadyVerified:
        return 'alreadyVerified';
      case EmailVerificationError.NotFound:
        return 'notFound';
      case EmailVerificationError.InvalidEmail:
        return 'invalidEmail';
      default:
        return 'default';
    }
  }
}
